export const zahtjev_pristup_informacijama= {
  templateId: 92,
  category: 9,
  templateTitle: "Zahtjev ispitanika za pristup informacijama - GDPR",
  templateDescription: `<p>Zahtjev na pristup informacija je pravo ispitanika koje proizlazi iz Uredbe, čije nepoštivanje od strane voditelja obrade je kažnjivo.</p>`,
  description: `
    <h5>OPIS  DOKUMENTA</h5>
    <p>Ispitanik ima pravo dobiti od voditelja obrade potvrdu obrađuju li se osobni podaci koji se odnose na njega te ako se takvi osobni podaci obrađuju, pristup osobnim podacima te ostalim informacijama koje se navode u Općoj Uredbi o zaštiti podataka.</p>
    <p>Napomena: ovaj dokument se ispunjava tek nakon ispisa na pisaču.</p>
   
    <h5>PRAVNA OSNOVA</h5>
    <p>UREDBA (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka).</p>
    `,
    sides: [
      {
          prefix: 'Na temelju Opće uredbe o zaštiti podataka,',

          signature: "Podnositelj zahtjeva:",
            inputs: [{
              type: "input",
              required: true,
              placeholder: "Ime i prezime",
            },
            {
              type: "input",
              required: false,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: false,
              placeholder: "Mjesto",
            },
            ],
      }
  ],
  headline: "podnosim sljedeći",
  title: "ZAHTJEV ZA PRISTUP INFORMACIJAMA",

  noArticleNumbers: true,

  articles: [  

    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "1. VODITELJ OBRADE:\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "NAZIV: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "SJEDIŠTE: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "ADRESA: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "OIB: _________________________\r\n"},
        
          ],
        }
      ]
    },
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "2. PODATAK KOJEMU SE TRAŽI PRISTUP (označiti odabir):\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "□ dostaviti potvrdu o tome obrađuju li se osobni podaci koji se odnose na ispitanika ili ne,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "□ dati obavijest u razumljivom obliku o podacima koji se odnose na ispitanika čija je obrada u tijeku te o izvoru tih podataka,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "□ omogućiti uvid u evidencije zbirke osobnih podataka te uvid u osobne podatke sadržane u zbirci osobnih podataka, kao i prepisivanje istih,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "□ dostaviti izvatke, potvrde ili ispise osobnih podataka sadržanih u zbirci,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "□ dostaviti ispis podataka o tome tko je i za koje svrhe i po kojem pravnom temelju dobio na korištenje osobne podatke koji se odnose na ispitanika,\\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "□ dati obavijest o logici bilo koje automatske obrade podataka koji se odnose na ispitanika."},
        
          ],
        }
      ]
    },
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "3. Zatraženi pristup podacima molimo dostaviti/omogućiti na sljedeći način:\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "________________________________________________________________________"},               
          ],
        }
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
  },
],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/92_zahtjev_pristup_informacijama.ts